import { DateTimePickerComponent } from "@/components/shared/date-time-picker-modal/date-time-picker.component";
import { useLadleHMContext } from "@/pages/configurations/ladleHeatMetrics/context/LadleHeatMetricContext";
import { updateLadleHeatMetrics } from "@/pages/configurations/ladleHeatMetrics/repositories/LadleHMRepository";
import {
	Button,
	CardContent,
	CircularProgress,
	Grid,
	Paper,
	Typography,
} from "@material-ui/core";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import { useState } from "react";
import { CheckmarkIcon, toast } from "react-hot-toast";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			"& .MuiSelect-outlined.MuiSelect-outlined": {
				height: "70vh",
				minWidth: "200px",
				width: "80%",
				minHeight: "100%",
			},
		},
	}),
);

type Props = {
	isLoading: boolean;
	getLadlesFromAPI: Function;
};

export const TableLadles = ({ isLoading, getLadlesFromAPI }: Props) => {
	const { state, actions } = useLadleHMContext();

	const classes = useStyles();

	const [selected, setSelected] = useState<string[]>(["all"]);
	const [internalValue, setInternalValue] = useState<Date | null>(null);

	const [showErrorModal, setShowErrorModal] = useState(false);
	const [localError, setLocalError] = useState<string | null>(null);

	const onLocalChange = (e: any) => {
		setSelected([...e.target.selectedOptions].map((o) => o.value));
	};

	const handleRecalculate = async () => {
		try {
			if (selected[0] === "all")
				await updateLadleHeatMetrics(
					selected[0],
					internalValue?.toISOString() || "",
				);
			else
				await updateLadleHeatMetrics(
					parseInt(selected[0]),
					internalValue?.toISOString() || "",
				);

			toast("Success!", {
				icon: <CheckmarkIcon />,
			});
		} catch (error) {
			setLocalError(error as string);
			setShowErrorModal(true);
		}
	};

	const ladleTitle = (rootNames: string[]) => {
		if (!rootNames[0]) return;
		if (rootNames[0] === "all") return "All";
		if (rootNames.length === 1) return "Ladle " + rootNames[0];
		else return "Ladle " + rootNames.join(", ");
	};

	return (
		<>
			{!isLoading ? (
				<>
					<Paper
						style={{
							width: "100%",
							padding: "20px",
							borderRadius: "0.75rem",
						}}
					>
						<Grid container>
							<Grid item xs={12}>
								<div
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
									}}
								>
									<Typography
										variant="h5"
										style={{ paddingBottom: "20px", fontWeight: 600 }}
									>
										Ladle Heat Metrics
									</Typography>
								</div>
							</Grid>

							<Grid item md={3} xs={12} style={{ paddingTop: "1rem" }}>
								<select
									className="form-control user-select-none text-center overflow-hidden"
									value={selected}
									onChange={onLocalChange}
									size={state.ladles.length + 1}
								>
									<option
										style={{ padding: "0.35rem", fontWeight: "bold" }}
										value={"all"}
									>
										All
									</option>
									{state.ladles?.map((ladle) => {
										return (
											<option
												style={{ padding: "0.35rem" }}
												value={ladle.rootName}
											>
												Ladle {ladle.rootName}
											</option>
										);
									})}
								</select>
							</Grid>

							<Grid item md={9} xs={12} style={{ paddingTop: "1px" }}>
								<CardContent>
									<DateTimePickerComponent
										value={internalValue}
										onChange={(date: Date) => setInternalValue(date)}
									/>
									<br />
								</CardContent>
							</Grid>
							<Grid item md={12}>
								<Button
									onClick={handleRecalculate}
									fullWidth={true}
									color="primary"
									variant="contained"
									disabled={selected.length === 0}
								>
									RECALCULATE {ladleTitle(selected)}
								</Button>
							</Grid>
						</Grid>
					</Paper>
				</>
			) : (
				<Grid
					container
					justifyContent="center"
					alignItems="center"
					style={{ minHeight: "60px", paddingTop: "15rem" }}
				>
					{/* <LazyLoading /> */}
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<CircularProgress size="3rem" />
					</div>
				</Grid>
			)}
		</>
	);
};
